(function($) {
$(function(){

    var $widgets = $('.latest-videos');
    if (!$widgets.length) return;

    $widgets.each(function(){
        var $widget = $(this);
        var $player = $widget.find('.latest-videos__player');
        var $thumbs = $widget.find('.latest-videos__thumb');

        function embedUrl(videoId) {
            return 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
        }

        function playVideo(videoId, title) {
            var $iframe = $('<iframe>', {
                src: embedUrl(videoId),
                title: title,
                allow: 'autoplay; encrypted-media; picture-in-picture',
                allowfullscreen: true,
                frameborder: 0
            });
            $player.empty().append($iframe);
        }

        function setActive($target) {
            $thumbs.removeClass('is-active');
            $target.addClass('is-active');
        }

        function openFallback(videoUrl) {
            window.open(videoUrl, '_blank', 'noopener');
        }

        $player.on('click', '.latest-videos__poster', function(e){
            e.preventDefault();
            var $poster = $(this);
            var videoId = $poster.attr('data-video-id');

            if (!videoId) {
                openFallback($poster.attr('data-video-url'));
                return;
            }

            playVideo(videoId, $poster.attr('aria-label'));
        });

        $widget.on('click', '.latest-videos__thumb', function(e){
            e.preventDefault();
            var $thumb = $(this);
            var videoId = $thumb.attr('data-video-id');

            if (!videoId) {
                openFallback($thumb.attr('data-video-url'));
                return;
            }

            playVideo(videoId, $thumb.attr('aria-label'));
            setActive($thumb);
        });
    });

});
})(jQuery);
